import { Chip, Grid } from '@material-ui/core'
import { LinkEdit } from 'Components/Link/Edit'
import { LinkView } from 'Components/Link/View'
import PropTypes from 'prop-types'
import React from 'react'
import { SOURCE_OPPIZI_ADS } from '../../../constants'
import CampaignFeaturesConfig from '../../../Containers/Form/Campaigns/CreateEditCampaign/CampaignFeaturesConfig'

/**
 *
 * @param {*} props.title e.g. {props.campaign.name || ''}
 * @param {*} props.subTitle e.g. {props.campaign.client.name}
 * @param {*} props.description
 * @param {*} props.footer e.g. {props.campaign.type}
 */
const CampaignCardUnstyled = props => {
  const { lastConversionDate } = props

  return (
    <div className={props.className} cypress_id={props.cypress_id}>
      <div onClick={props.onClick && props.onClick.bind(null, props.campaign)}>
        <div className="name">
          <div className={'campaign-status'} />
          <img src={props.img || ''} alt="logo" />
          <div
            className={'campaign-name'}
            cypress_id={props.cypress_id + '-campaign-name'}
          >
            {props.title}
          </div>
          <div className={'client-name'}>{props.subTitle}</div>
          <div
            onClick={async event => {
              event.preventDefault()
              event.stopPropagation()
              event.persist()
              try {
                const content = event.target.textContent
                await navigator.clipboard.writeText(content)
                event.target.textContent = 'Copied!'
                setTimeout(() => {
                  event.target.textContent = content
                }, 1500) // Reset after a short time
              } catch (err) {
                console.error('Failed to copy text: ', err)
              }
            }}
            className={'campaign-id'}
          >
            {props.campaignId}
          </div>
        </div>
        {props.isSelfServe ? (
          <Chip size="small" label={SOURCE_OPPIZI_ADS} />
        ) : null}
        <div className="duration-archived-company">
          {props.campaignTimeRange}
        </div>
        <div className="number-of-cities">
          {CampaignFeaturesConfig(props.footer).disableCityFeatures ? (
            <div>&nbsp;</div> // Using &nbsp to maintain correct component height
          ) : (
            props.description
          )}
        </div>
        <div className="number-of-cities">{props.footer}</div>
      </div>
      {props.viewPath && props.editPath && (
        <Grid container>
          <Grid item xs={6} className="actions">
            <LinkView
              to={props.viewPath}
              label="View"
              cypress_id="campaign-card-view-button"
            />
            <LinkEdit
              to={props.editPath}
              label="Edit"
              cypress_id="campaign-card-edit-button"
            />
          </Grid>
          {lastConversionDate ? (
            <Grid item xs={6} className="text-right">
              Updated on <br /> {lastConversionDate}
            </Grid>
          ) : null}
        </Grid>
      )}
    </div>
  )
}
CampaignCardUnstyled.propTypes = {
  viewPath: PropTypes.string,
  editPath: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  campaign: PropTypes.shape({
    name: PropTypes.string,
    cities: PropTypes.array,
    client: PropTypes.shape({
      logo: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
  }).isRequired,
}

export { CampaignCardUnstyled }
